// extracted by mini-css-extract-plugin
export default {"root":"v-ITXrz"};